const firebaseConfig = {
    apiKey: "AIzaSyBUr2pZ1ymT0iD2jIzQ7tBKY96svkoKRCM",
    authDomain: "travel-guru-v1.firebaseapp.com",
    databaseURL: "https://travel-guru-v1.firebaseio.com",
    projectId: "travel-guru-v1",
    storageBucket: "travel-guru-v1.appspot.com",
    messagingSenderId: "13894437753",
    appId: "1:13894437753:web:369f71a5d7b45412073da8"
  };

  export default firebaseConfig;